import React from 'react';
import { toast } from "react-toastify";

import ModalConfirmAction from '../../_other/ModalConfirmAction';
import AdminModalAddNewUser from "./AdminModalAddNewUser";

import {Button,ButtonToolbar,Form} from 'react-bootstrap'

import { serverService } from '../../../_services/server.service';

import './AdminUsersTable.css'


import moment from 'moment'

const $ = require('jquery');
$.DataTable = require('datatables.net');

require( 'datatables.net-bs4' );
require( 'datatables.net-select-bs4' );
require('../../datatables.selected.css');

const columns = [
    {
        title: 'Username',
        width: 200,
        data: 'Username'
    },
    {
        title: 'Company',
        width: 200,
        data: 'Company'
    },
    {
        title: 'Timezone',
        width: 200,
        data: 'Timezone'
    },
];


interface MyProps {
    users:any,
    onUserAdded(extra:string):any,
    onUserEdited(extra:string):any,
    onUserDeleted():any,
}

interface MyState {
    submitted: boolean,
    modalAddNewShow:boolean,
    modalConfirmDeleteShow: boolean,
    selectedUser: any,
    formFields:any,
}

class AdminUsersTable extends React.Component<MyProps,MyState> {
    constructor(props) {
        super(props);

        this.state = {
            submitted:false,
            modalAddNewShow:false,
            modalConfirmDeleteShow:false,
            formFields:{},
            selectedUser:{}
        };


        this.onUserAdded = this.onUserAdded.bind(this);
        this.onUserEdited = this.onUserEdited.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    componentDidMount() {
        let table = $(this.refs.main).DataTable({
            dom: "<'data-table-wrapper'" +
                    "<'row'<'col-md-6'<'toolbar'>><'col-md-6'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row'<'col-sm-12 col-md-5'><'col-sm-12 col-md-7'p>>" +
                    ">",
            data: this.props.users,
            columns,
            ordering: true,
            paging:true,
            select: {
                style: 'single',
                //blurable: true
            },

            columnDefs: [
                { width: 300, targets: 0 },
                { width: 200, targets: 1 },
            ]
        });

        $("#deleteBtn").hide();
        $("#editBtn").hide();

        table.on( 'select', function ( e, dt, type, indexes ) {
            $("#deleteBtn").show();
            $("#editBtn").show();
        });

        table.on( 'deselect', function ( e, dt, type, indexes ) {
            $("#deleteBtn").hide();
            $("#editBtn").hide();
        });

    }

    componentWillUnmount(){
        $('.data-table-wrapper')
            .find('table')
            .DataTable()
            .destroy(true);
    }

    componentDidUpdate(oldProps) {
        if(this.props.users !== oldProps.users){
            reloadTableData(this.props.users);
        }
    }

    render() {
        let modalAddNewOpen = (itemToEdit) => this.setState({ modalAddNewShow: true, selectedUser:itemToEdit });
        let closeAddNewModal = () => this.setState({ modalAddNewShow: false });

        let modalConfirmDeleteOpen = (itemToEdit) => {
            const table = $('.data-table-wrapper')
                .find('table')
                .DataTable();
            let data = table.rows( { selected: true }).data();

            this.setState({ modalConfirmDeleteShow: true });
        };
        let modalConfirmDeleteClose = () => this.setState({ modalConfirmDeleteShow: false });

        let deleteSelectedItemWithConfirmation = () => {
            modalConfirmDeleteOpen(null);
        };


        let editSelectedItem = () => {
            const table = $('.data-table-wrapper')
                .find('table')
                .DataTable();
            let data = table.rows( { selected: true }).data();

            modalAddNewOpen(data[0]);

        };


        let deleteSelectedItem = () => {
            const table = $('.data-table-wrapper')
                .find('table')
                .DataTable();

            let data = table.rows( { selected: true }).data();

            let IdUser = data[0].IdUser;

            serverService.deleteUser(IdUser)
                .then(
                    result => {
                        if(result.status == 1){
                            toast.success("User deleted");
                            $("#deleteBtn").hide();
                            this.props.onUserDeleted();
                        } else {
                            toast.error("Delete failed");
                        }

                        this.setState({ modalConfirmDeleteShow: false });
                    },
                    error => {
                        toast.warn("Did not delete user");
                    }
                );
        };


        return (
            <div className="row">
                <div  className="col-md-12" id="usersTableContainer">

                    <table ref="main" className="table table-bordered usersTable" />

                    <div className="float-right">

                        <ButtonToolbar>

                            <Button
                                id="editBtn"
                                variant="light"
                                onClick={editSelectedItem}
                            >
                                Edit
                            </Button>
                            &nbsp;
                            <Button
                                id="deleteBtn"
                                variant="light"
                                onClick={deleteSelectedItemWithConfirmation}
                            >
                                Delete
                            </Button>

                            &nbsp;

                            <Button
                                id="addBtn"
                                variant="light"
                                onClick={modalAddNewOpen}
                            >
                                Add
                            </Button>

                        </ButtonToolbar>

                    </div>

                    <AdminModalAddNewUser
                        show={this.state.modalAddNewShow}
                        selectedUser={this.state.selectedUser}
                        onHide={closeAddNewModal}
                        onUserAdded={this.onUserAdded}
                        onUserEdited={this.onUserEdited}
                    />

                    <ModalConfirmAction
                        show={this.state.modalConfirmDeleteShow}
                        actionTitle="Confirm delete"
                        actionBody="Are you sure you want to delete the selected user?"
                        noBtnText="No, go back"
                        yesBtnText="Yes, confirm"
                        onConfirmNo={modalConfirmDeleteClose}
                        onHide={modalConfirmDeleteClose}
                        onConfirmYes={deleteSelectedItem}
                    />

                </div>


            </div>);
    }


    onUserAdded(item){
        this.props.onUserAdded(item);
        this.setState({modalAddNewShow: false});
    }

    onUserEdited(item){
        this.props.onUserEdited(item);
        this.setState({modalAddNewShow: false});
    }



    handleChange(e) {
        const { name, value } = e.target;
        let formFields = this.state.formFields;
        formFields[name] = value;
        this.setState({ formFields: formFields });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({submitted: true});

        const { formFields } = this.state;
        const Name = formFields.Name;

        // stop here if form is invalid
        if (!(Name)) {
            toast.error("Missing fields");
            return;
        }

        let userStr = localStorage.getItem('user');
        let IdCompany = 0;
        if(userStr) {
            let userObj = JSON.parse(userStr);
            IdCompany = userObj.IdCompany;
        } 

        let user = {'IdUser': '0','IdCompany':IdCompany.toString(), 'Name': Name };
        serverService.insertUser(user)
            .then(
                result => {
                    if(result.status == 1){ 

                        
                        
                        let messageStr = "User added";
                        toast.success(messageStr);
                        this.props.onUserAdded(result.extra);

                        let formFields = this.state.formFields;
                        formFields.Name = "";
                        this.setState({ formFields: formFields });
                    } else {
                        toast.error("Add user failed");
                    }
                },
                error => {
                    toast.warn("Did not insert user");
                }
            );
    }
}

function reloadTableData(items) {
    const table = $('.data-table-wrapper')
        .find('table')
        .DataTable();
    table.clear();
    table.rows.add(items);
    table.draw();

    $("#deleteBtn").hide();
    $("#editBtn").hide();
}

export default AdminUsersTable;
